@let groups = cardGroups;

<ng-template #stepGroup
             let-group>
  @if (group.items.length > 0) {
    @if (group.label) {
      <h3 class="step-group-label"
          [attr.data-testid]="'cm-label-steps-' + group.key">{{ group.label }}</h3>
    }
    <div class="step-group"
         [attr.data-testid]="'cm-container-steps-' + group.key">
      @for (card of group.items; track card.job.id) {
        <button type="button"
                class="step-card"
                [class.step-card--active]="card.status === ScoreCardStatus.Active"
                [class.step-card--complete]="card.status === ScoreCardStatus.Complete"
                (click)="onCardClick(card)"
                [attr.data-testid]="'cm-card-bq' + card.job.buildQualityStep">
          <span class="step-card-icon"
                aria-hidden="true">
            @switch (card.status) {
              @case (ScoreCardStatus.Active) {
                <i class="pi pi-home"></i>
              }
              @case (ScoreCardStatus.Complete) {
                <i class="pi pi-check-circle"></i>
              }
              @default {
                <i class="pi pi-calendar-clock"></i>
              }
            }
          </span>
          <span class="step-card-body">
            <span class="step-card-title-row">
              <span class="step-card-title"
                    [attr.data-testid]="'cm-text-bq' + card.job.buildQualityStep + '-title'">{{ card.title }}</span>
              @if (card.status === ScoreCardStatus.Active) {
                <p-tag value="Active"
                       severity="warn"
                       [rounded]="true" />
              }
            </span>
            <span class="step-card-subtext"
                  [attr.data-testid]="'cm-text-bq' + card.job.buildQualityStep + '-subtext'">{{ card.subtext }}</span>
          </span>
          <i class="pi pi-chevron-right step-card-chevron"
             aria-hidden="true"></i>
        </button>
      }
    </div>
  }
</ng-template>

<ng-container [ngTemplateOutlet]="stepGroup"
              [ngTemplateOutletContext]="{ $implicit: groups[0] }" />

<div class="steps-collapsible"
     [class.is-expanded]="showAllSteps"
     [attr.inert]="showAllSteps ? null : ''"
     data-testid="cm-container-steps-collapsible">
  <div class="steps-collapsible-inner">
    <ng-container [ngTemplateOutlet]="stepGroup"
                  [ngTemplateOutletContext]="{ $implicit: groups[1] }" />
    <ng-container [ngTemplateOutlet]="stepGroup"
                  [ngTemplateOutletContext]="{ $implicit: groups[2] }" />
  </div>
</div>

<app-standard-bottom-sheet [(isOpen)]="isStepSheetOpen"
                           [title]="stepSheetTitle"
                           (overlayClick)="closeStepSheet()"
                           testId="cm-sheet-pending-step">
  <p class="step-sheet-message"
     data-testid="cm-text-pending-step-message">
    @if (stepSheetMessage; as message) {
      {{ message.leading }}<strong>{{ message.emphasis }}</strong>{{ message.trailing }}
    }
  </p>
  <app-vertical-button-group [buttons]="stepSheetButtons"
                             testId="cm-container-pending-step-actions" />
</app-standard-bottom-sheet>

<p-dialog dismissableMask="true"
          [styleClass]="'pre-closing-modal'"
          showHeader="false"
          [modal]="true"
          [(visible)]="preClosingModalOpen">
  @if (activeJob && lot) {
    <div class="pre-closing-modal-container"
         data-testid="cm-modal-pre-closing">
      <div class="pre-closing-modal-content"
           data-testid="cm-container-pre-closing-content">
        <div class="pre-closing-modal-header"
             data-testid="cm-header-pre-closing">
          <img height="30px"
               width="30px"
               src="assets/icons/check.svg">
          <div class="pre-closing-header-container">
            <div class="header-md-bold center-text">
              {{ activeJobDefinition?.detailsTitle }}
            </div>
            <div class="body-md-regular pre-closing-detail">
              <div data-testid="cm-text-pre-closing-address">
                {{ lot.streetAddress }}
              </div>
              <div data-testid="cm-text-pre-closing-lot">
                {{ lot.salesCommunityName }} , Lot {{ lot.lotBlock }}
              </div>
            </div>
          </div>
        </div>
        <div class="body-md-regular pre-closing-detail"
             data-testid="cm-text-pre-closing-date">
          Completed {{ activeJob.submittedAt | date }}
        </div>
        <div class="body-sm-regular pre-closing-detail pre-closing-issue-count"
             data-testid="cm-text-pre-closing-issue-count">
          {{ activeJobIssueCount }} {{ activeJobIssueCount === 1 ? "Item" : "Items" }} Reported
        </div>
      </div>
      <div class="pre-closing-modal-separator"></div>
      <app-horizontal-button-group [buttons]="detailsActions"
                                   testId="cm-container-pre-closing-actions" />
    </div>
  }
</p-dialog>